<script setup lang="ts">
import { ref } from 'vue'
import { usePageContext } from '@/composables/usePageContext'
import AppNavigation from '@/ui-kit/layout/AppNavigation.vue'
import VPurchaseStatus from '@/ui-kit/components/PurchaseStatus/PurchaseStatus.vue'
import type { PaymentModalExpose } from '~/ui-kit/components/PaymentModal/PaymentModal.vue'

interface PurchaseButton {
  buttonType: 'purchase' | 'view' | 'pay' | 'custom'
  buttonText: string
  buttonLink: string
}

interface PurchaseDiscount {
  base_price: number
  discount_percent: number
  reason?: string
}

interface PurchaseStatus {
  lock_reason: string | null
  price: number | null
  status_code: string
  button: PurchaseButton | null
  discount: PurchaseDiscount | null
}

interface TeachYourselfBookDescriptionContext {
  book_id: number
  book_name: string
  purchase_status: PurchaseStatus
  description_html: string
}

const ctx = usePageContext<TeachYourselfBookDescriptionContext>()
const paymentModal = ref<PaymentModalExpose | null>(null)

function purchaseBook() {
  paymentModal.value?.open({
    enableCredit: true,
    query: { book_id: ctx.book_id },
    order: {
      price: Number(ctx.purchase_status.price ?? 0),
      name: `Самоучитель ${ctx.book_name}`
    }
  })
}
</script>

<template>
  <div class="account-frame">
    <AppNavigation role="teacher" rules-url="/website/documents/oferta" />

    <div class="content">
      <v-payment-modal ref="paymentModal" url="/seminars/request_purchase_teachyourselfbook" />

      <div class="header">О Самоучителе</div>
      <div class="title">{{ ctx.book_name }}</div>

      <VPurchaseStatus
        :lock-reason="ctx.purchase_status.lock_reason || ''"
        :price="ctx.purchase_status.price"
        :status-code="ctx.purchase_status.status_code"
        :button="ctx.purchase_status.button"
        :discount="ctx.purchase_status.discount"
        @click="purchaseBook"
      />

      <div class="text" v-html="ctx.description_html" />

      <VPurchaseStatus
        secondary
        :lock-reason="ctx.purchase_status.lock_reason || ''"
        :price="ctx.purchase_status.price"
        :status-code="ctx.purchase_status.status_code"
        :button="ctx.purchase_status.button"
        :discount="ctx.purchase_status.discount"
        @click="purchaseBook"
      />
    </div>
  </div>
</template>
